import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/arrow.svg'
import _imports_1 from '../../assets/share-blue.png'
import _imports_2 from '../../assets/update.png'
import _imports_3 from '../../assets/bus-gray-icon.png'
import _imports_4 from '../../assets/map2.png'
import _imports_5 from '../../assets/check.png'


const _hoisted_1 = { class: "bus-route-status" }
const _hoisted_2 = { class: "action-section" }
const _hoisted_3 = { class: "action-section__bus-number" }
const _hoisted_4 = { class: "update-hint" }
const _hoisted_5 = { class: "info-section" }
const _hoisted_6 = { class: "info-section__name" }
const _hoisted_7 = { class: "info-section__way" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Share"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 分享頁面 ")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "main-info" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", null, "公車動態", -1)
const _hoisted_17 = { class: "bus-status" }
const _hoisted_18 = { class: "button-tabs" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_21 = { class: "bus-status__list-container" }
const _hoisted_22 = { class: "bus-status__status-list" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 1,
  class: "status no-departure"
}
const _hoisted_25 = { class: "current-station" }
const _hoisted_26 = { class: "bus-status__map" }
const _hoisted_27 = { class: "bus-map" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 站牌地圖 ")
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "route-info" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h3", null, "路線資訊", -1)
const _hoisted_35 = { class: "route-info__box-container" }
const _hoisted_36 = { class: "route-info__box" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h4", null, "發車資訊", -1)
const _hoisted_38 = { class: "route-info__box-detail" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h5", null, "頭末班車：", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h5", null, "營運日期：", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "operation-time-list" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "day" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "day__text" }, " 一 "),
    /*#__PURE__*/_createElementVNode("div", { class: "day__check" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_5,
        alt: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "day" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "day__text" }, " 二 "),
    /*#__PURE__*/_createElementVNode("div", { class: "day__check" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_5,
        alt: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "day" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "day__text" }, " 三 "),
    /*#__PURE__*/_createElementVNode("div", { class: "day__check" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_5,
        alt: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "day" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "day__text" }, " 四 "),
    /*#__PURE__*/_createElementVNode("div", { class: "day__check" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_5,
        alt: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "day" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "day__text" }, " 五 "),
    /*#__PURE__*/_createElementVNode("div", { class: "day__check" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_5,
        alt: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "day" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "day__text" }, " 六 "),
    /*#__PURE__*/_createElementVNode("div", { class: "day__check" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_5,
        alt: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "day" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "day__text" }, " 日 "),
    /*#__PURE__*/_createElementVNode("div", { class: "day__check" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_5,
        alt: ""
      })
    ])
  ])
], -1)
const _hoisted_42 = { class: "route-info__box" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h4", null, "票價資訊", -1)
const _hoisted_44 = { class: "route-info__box-detail" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("h5", null, "收費方式：", -1)
const _hoisted_46 = { class: "route-info__box" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h4", null, "服務客運", -1)
const _hoisted_48 = { class: "route-info__box-detail" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("h5", null, "客運業者：", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h5", null, "聯繫電話：", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingPage = _resolveComponent("LoadingPage")!
  const _component_HeaderBar = _resolveComponent("HeaderBar")!
  const _component_RouteMap = _resolveComponent("RouteMap")!
  const _component_BaseLayout = _resolveComponent("BaseLayout")!
  const _component_BusRouteInfoDialog = _resolveComponent("BusRouteInfoDialog")!
  const _component_BusRouteMapDialog = _resolveComponent("BusRouteMapDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
        : _createCommentVNode("", true)
    ])),
    _createVNode(_component_BaseLayout, null, {
      header: _withCtx(() => [
        _createVNode(_component_HeaderBar)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
            }),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.currentCity) + "｜" + _toDisplayString(_ctx.busName) + " 公車", 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.currentSecond) + "秒後更新", 1)
          ]),
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.busName), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.busRouteInfo[0]?.DepartureStopNameZh) + " - " + _toDisplayString(_ctx.busRouteInfo[0]?.DestinationStopNameZh), 1),
            _createElementVNode("div", {
              class: "info-section__more-info",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openRouteInfo && _ctx.openRouteInfo(...args)))
            }, _hoisted_9),
            _createElementVNode("div", {
              class: "info-section__share-button button pc",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sharePageInfo && _ctx.sharePageInfo(...args)))
            }, _hoisted_12),
            _createElementVNode("div", {
              class: "info-section__update",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateRouteStatus && _ctx.updateRouteStatus(...args)))
            }, _hoisted_14)
          ]),
          _createElementVNode("section", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("article", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: _normalizeClass(["bus-status__way-button", {inactive: _ctx.selectedBusDirection !== 0}]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeBusDirection('Outbound')))
                }, [
                  _hoisted_19,
                  _createTextVNode(" 往 " + _toDisplayString(_ctx.busRouteInfo[0]?.DestinationStopNameZh), 1)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["bus-status__way-button", {inactive: _ctx.selectedBusDirection !== 1}]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeBusDirection('Return')))
                }, [
                  _hoisted_20,
                  _createTextVNode(" 往 " + _toDisplayString(_ctx.busRouteInfo[0]?.DepartureStopNameZh), 1)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wholeBusStops, (stop) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "bus-status__item",
                      key: stop.StopID,
                      onClick: ($event: any) => (_ctx.goStopInfo(stop))
                    }, [
                      (stop.StopStatus === 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["status", _ctx.getStopStatusClass(stop.EstimateTime)])
                          }, _toDisplayString(_ctx.estimatedArriveTimeFilter(stop.EstimateTime)), 3))
                        : (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.statusFilter(stop.StopStatus)), 1)),
                      _createElementVNode("div", _hoisted_25, _toDisplayString(stop.StopName?.Zh_tw), 1)
                    ], 8, _hoisted_23))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_RouteMap, {
                    geometryArray: _ctx.geometryArray,
                    wholeBusStops: _ctx.wholeBusStops
                  }, null, 8, ["geometryArray", "wholeBusStops"])
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_27, [
            _createElementVNode("div", {
              class: "bus-map__button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowRouteMap = true))
            }, _hoisted_30),
            _createElementVNode("div", {
              class: "bus-map__refresh-button",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updateRouteStatus && _ctx.updateRouteStatus(...args)))
            }, _hoisted_32)
          ]),
          _createElementVNode("section", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("p", null, "平日：" + _toDisplayString(_ctx.busRouteInfo[0]?.SubRoutes[0].FirstBusTime) + "-" + _toDisplayString(_ctx.busRouteInfo[0]?.SubRoutes[0].LastBusTime), 1),
                  _createElementVNode("p", null, "假日：" + _toDisplayString(_ctx.busRouteInfo[0]?.SubRoutes[0].HolidayFirstBusTime) + "-" + _toDisplayString(_ctx.busRouteInfo[0]?.SubRoutes[0].HolidayLastBusTime), 1),
                  _hoisted_40,
                  _hoisted_41
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("p", null, _toDisplayString(_ctx.busRouteInfo[0]?.TicketPriceDescriptionZh || '-'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createElementVNode("p", null, _toDisplayString(_ctx.busOperatorInfo?.OperatorName.Zh_tw), 1),
                  _hoisted_50,
                  _createElementVNode("p", null, _toDisplayString(_ctx.busOperatorInfo?.OperatorPhone), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isShowRouteInfo)
        ? (_openBlock(), _createBlock(_component_BusRouteInfoDialog, {
            key: 0,
            busOperatorInfo: _ctx.busOperatorInfo,
            busRouteInfo: _ctx.busRouteInfo,
            onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowRouteInfo = false))
          }, null, 8, ["busOperatorInfo", "busRouteInfo"]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isShowRouteMap)
        ? (_openBlock(), _createBlock(_component_BusRouteMapDialog, {
            key: 0,
            onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isShowRouteMap = false)),
            geometryArray: _ctx.geometryArray
          }, null, 8, ["geometryArray"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}